import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/images/logo.png';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const closeSidebar = () => setIsOpen(false);

  return (
    <>
      {/* Sidebar */}
      <aside
        className={`
          fixed top-0 right-0 z-40 transition-transform duration-300
          h-full w-64 bg-gray-50 dark:bg-gray-800 border-l border-gray-400
          ${isOpen ? 'translate-x-0' : 'translate-x-full'}
          md:relative md:translate-x-0 md:block
        `}
        aria-label='Sidebar'
      >
        <div className='py-6 px-3 h-full relative'>
          <img src={Logo} alt='Logo' className='pl-2' style={{ maxWidth: '90%' }} />
          <ul className='space-y-2 font-vt323 text-left mt-5 text-2xl'>
            <li>
              <Link  onClick={closeSidebar} to='/' className='flex items-center p-2 rounded-lg dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700'>
                <span className='ml-3 text-4xl'>Home</span>
              </Link>
            </li>
            <li>
              <Link  onClick={closeSidebar} to='/howtobuy' className='flex items-center p-2 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700'>
                <span className='ml-3 text-4xl'>How To Buy</span>
              </Link>
            </li>
            <li>
              <Link  onClick={closeSidebar} to='/origin' className='flex items-center p-2 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700'>
                <span className='ml-3 text-4xl'>Reddit</span>
              </Link>
            </li>
            <li>
              <Link  onClick={closeSidebar} to='/dex' className='flex items-center p-2 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700'>
                <span className='ml-3 text-4xl'>Dex</span>
              </Link>
            </li>
            <li>
              <Link  onClick={closeSidebar} to='/chart' className='flex items-center p-2 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700'>
                <span className='ml-3 text-4xl'>Chart</span>
              </Link>
            </li>
          </ul>

          {/* Close button */}
          <button
            onClick={closeSidebar}
            className='absolute bottom-6 right-6 z-50 bg-red-600 text-white w-14 h-14 flex items-center justify-center rounded-full shadow-lg md:hidden'
            aria-label='Close Sidebar'
            >
            <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-6 w-6'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                strokeWidth={2}
            >
                <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
            </svg>
            </button>

        </div>
      </aside>

      {/* Hamburger Button */}
      {!isOpen && (
        <button
        onClick={toggleSidebar}
        className='fixed bottom-6 right-6 z-50 bg-gray-800 text-white w-14 h-14 flex items-center justify-center rounded-full shadow-lg md:hidden'
        aria-label='Open Sidebar'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          className='h-6 w-6'
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
          strokeWidth={2}
        >
          <path strokeLinecap='round' strokeLinejoin='round' d='M4 6h16M4 12h16M4 18h16' />
        </svg>
      </button>
      
      )}
    </>
  );
};

export default Sidebar;
